import React from 'react';
import { Control, FieldPath, FieldValues } from 'react-hook-form';

import { Checkbox } from '@/components/ui/checkbox';
import { FormControl, FormItem, FormLabel, FormMessage, FormField as ShadcnFormField } from '@/components/ui/form';

interface FormCheckboxProps<TFieldValues extends FieldValues> {
    control: Control<TFieldValues>;
    name: FieldPath<TFieldValues>;
    label: string;
    disabled?: boolean;
}

export function FormCheckbox<TFieldValues extends FieldValues>({
    control,
    name,
    label,
    disabled = false,
}: FormCheckboxProps<TFieldValues>) {
    return (
        <ShadcnFormField
            control={control}
            name={name}
            render={({ field }) => (
                <FormItem className="flex flex-row items-start space-y-0 space-x-3">
                    <FormControl>
                        <Checkbox checked={field.value} onCheckedChange={field.onChange} disabled={disabled} />
                    </FormControl>
                    <div className="space-y-1 leading-none">
                        <FormLabel>{label}</FormLabel>
                    </div>
                    <FormMessage />
                </FormItem>
            )}
        />
    );
}
